import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { setLoading } from "../../reducer/auth/auth";
import { confirmGift, isOk, messageOf } from "../../services/gift";
import GiftCard from "./components/GiftCard";
import GiftCardActions from "./components/GiftCardActions";
import GiftSendPanel from "./components/GiftSendPanel";
import { Check } from "./components/GiftShell";
import "./gift.css";
import "./redeem.css";

const RETRIES = 4;

// Stripe's success_url for the $2 fee: /gift-created?session_id=cs_...
// The backend re-checks the session with Stripe before showing the code.
export default function GiftCreated() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [card, setCard] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const sessionId = new URLSearchParams(location.search).get("session_id");
    if (!sessionId) {
      setError("We couldn't find your payment. Please check My Gifts.");
      return;
    }

    let cancelled = false;
    const attempt = async (left) => {
      dispatch(setLoading(true));
      const res = await confirmGift(sessionId);
      if (cancelled) return;
      if (isOk(res)) {
        dispatch(setLoading(false));
        setCard(res.data.data);
      } else if (left > 0) {
        // Stripe may still be finalising the payment; try again shortly.
        setTimeout(() => attempt(left - 1), 2000);
      } else {
        dispatch(setLoading(false));
        setError(messageOf(res, "We couldn't confirm your payment yet. Please check My Gifts in a minute."));
      }
    };
    attempt(RETRIES);

    return () => {
      cancelled = true;
      dispatch(setLoading(false));
    };
  }, []);

  return (
    <div className="vsr-page vsr-inner">
      {card ? (
        <div className="vsr-stack">
          <div className="vsr-card vsr-created-hero no-print">
            <span className="vsr-icon-badge vsr-icon-badge-success" aria-hidden="true">
              <Check />
            </span>
            <div>
              <h1 className="vsr-title vsr-title-left vsr-title-sm">Your VerySoul Gift is ready</h1>
              <p className="vsr-lead vsr-lead-left">
                Give this card or the Gift Code to anyone you choose. We've also emailed you a receipt with the code, and you can
                reprint the card any time from <Link to="/my-gifts">My Gifts</Link>.
              </p>
            </div>
          </div>
          <GiftSendPanel gift={card} />
          <div className="vsr-card vsr-card-panel">
            <GiftCard code={card.code} qrSvg={card.qr_svg} redeemUrl={card.redeem_url} />
            <GiftCardActions code={card.code} redeemUrl={card.redeem_url} />
          </div>
        </div>
      ) : (
        error && (
          <div className="vsr-center">
            <section className="vsr-card vsr-reserved">
              <h1 className="vsr-title">Almost there</h1>
              <p className="vsr-lead">{error}</p>
              <div className="vsr-actions">
                <Link className="vsr-btn" to="/my-gifts">
                  Go to My Gifts
                </Link>
              </div>
            </section>
          </div>
        )
      )}
    </div>
  );
}
